
import { useState } from 'react';
import { Link } from 'react-router-dom';
import ContactModal from './ContactModal';

const Footer = () => {
  const [showContactModal, setShowContactModal] = useState(false);

  return (
    <>
      <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {/* Company Info */}
            <div>
              <h3 className="text-xl font-bold mb-4">Premium Marketplace</h3>
              <p className="text-gray-400 text-sm mb-4">
                Your trusted platform for discovering premium products and earning commissions. Join thousands of successful affiliates today.
              </p>
              <div className="flex gap-3">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-primary rounded-full transition-colors cursor-pointer"
                  aria-label="Follow us on Facebook"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-primary rounded-full transition-colors cursor-pointer"
                  aria-label="Follow us on Twitter"
                >
                  <i className="ri-twitter-x-fill"></i>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-primary rounded-full transition-colors cursor-pointer"
                  aria-label="Follow us on Instagram"
                >
                  <i className="ri-instagram-fill"></i>
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-primary rounded-full transition-colors cursor-pointer"
                  aria-label="Connect on LinkedIn"
                >
                  <i className="ri-linkedin-fill"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/products" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    Products
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    About Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div>
              <h4 className="font-bold mb-4">Support</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/dashboard" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    Help Center
                  </Link>
                </li>
                <li>
                  <button 
                    onClick={() => setShowContactModal(true)}
                    className="text-gray-400 hover:text-primary transition-colors cursor-pointer text-left"
                  >
                    Contact Us
                  </button>
                </li>
                <li>
                  <Link to="/about" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-gray-400 hover:text-primary transition-colors cursor-pointer">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="font-bold mb-4">Get In Touch</h4>
              <ul className="space-y-3 text-sm text-gray-400">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line mt-1"></i>
                  <a href="mailto:support@yoursite.com" className="hover:text-primary transition-colors cursor-pointer">
                    support@yoursite.com
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line mt-1"></i>
                  <a href="tel:+1234567890" className="hover:text-primary transition-colors cursor-pointer">
                    +1 (234) 567-890
                  </a>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-1"></i>
                  <span>123 Business St, Suite 100<br />New York, NY 10001</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-gray-700">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
              <p>© 2024 Premium Marketplace. All rights reserved.</p>
              <div className="flex items-center gap-4">
                <a 
                  href="https://readdy.ai/?ref=logo" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-primary transition-colors cursor-pointer"
                >
                  Website Builder
                </a>
                <span>•</span>
                <button 
                  onClick={() => setShowContactModal(true)}
                  className="hover:text-primary transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Contact Modal */}
      <ContactModal 
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
      />
    </>
  );
};

export default Footer;
